const PORT = window.location.port && window.location.port !== '80' ? ':' + process.env.REACT_APP_API_PORT : '';
const BASE_URL = window.location.protocol + '//' + window.location.hostname + PORT;

export const getGalleryList = () => fetch(BASE_URL + '/galleries').then(response => response);

export const saveGallery = galleryData =>
  fetch(BASE_URL + '/savegallery', {
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(galleryData),
  });
